import { makeAutoObservable } from 'mobx';

export class ManagementTeamsService {
  searchTerm = '';
  isCreateModalOpen = false;
  page = 0;
  rowsPerPage = 50;
  teamInfo: any = null;

  constructor() {
    makeAutoObservable(this);
  }

  setTeamInfo(info: any) {
    this.teamInfo = info;
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
  }

  setIsCreateModalOpen(isOpen: boolean) {
    this.isCreateModalOpen = isOpen;
  }

  setPage(page: number) {
    this.page = page;
  }

  setRowsPerPage(rowsPerPage: number) {
    this.rowsPerPage = rowsPerPage;
  }

  reset() {
    this.searchTerm = '';
    this.isCreateModalOpen = false;
    this.page = 0;
    this.rowsPerPage = 50;
    this.teamInfo = null;
  }
}

export const managementTeamsService = new ManagementTeamsService();
